module.exports = __webpack_public_path__ + "static/media/icLandingPersonalize.4e3f78e0.png";